module.exports = __webpack_public_path__ + "img/aponix-1.08f80035.jpg";